export class Usuario {
    id?: string;
    nome?: string;
    cpf: string;
    dataNascimento: string;
    telefone?: string;
    email?: string;
    senha?: string;
    contrato?: string;
    acaoSobreContrao?: string;
    token?: string;
}
